import React from 'react';
import classNames from 'classnames';

import css from './MessageImage.module.css';

/**
 * Component for displaying images in messages
 * 
 * @component
 * @param {Object} props - The props
 * @param {Object} props.image - The image data from ShareTribe
 * @param {string} [props.className] - Custom class that extends the default class for the root element
 * @param {string} [props.rootClassName] - Custom class that extends the default class for the root element
 * @param {boolean} [props.isOwnMessage] - Whether this is the current user's message
 * @returns {JSX.Element} The MessageImage component
 */
const MessageImage = props => {
  const { 
    rootClassName, 
    className, 
    image, 
    isOwnMessage = false 
  } = props;

  if (!image || !image.url) {
    return null;
  }

  const classes = classNames(rootClassName || css.root, className, {
    [css.ownMessage]: isOwnMessage,
  });

  return (
    <div className={classes}>
      <div className={css.imageContainer}>
        <img
          className={css.messageImage}
          alt="Message attachment"
          src={image.url}
          style={{
            maxWidth: '100%',
            maxHeight: '300px',
            objectFit: 'cover',
            borderRadius: '8px',
          }}
        />
      </div>
    </div>
  );
};

export default MessageImage;
